export default "__VITE_ASSET__BJ7pq0rF__"